import * as React from 'react';
import {cn} from 'src/lib/utils';
import {useScrollRestoration} from 'src/useScrollRestoration';

type Props = {
  header?: React.ReactNode;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  /**
   * List state that affects the rendered rows but is not reflected in the
   * URL (e.g. a filter held in component state). Scroll offsets are keyed by
   * URL + this value, so an offset saved under one filter state is never
   * restored onto another.
   */
  scrollStateKey?: string;
};

export const ScrollTable = ({
  header,
  body,
  footer,
  className,
  scrollStateKey,
}: Props) => {
  const scrollRef = useScrollRestoration(scrollStateKey);
  return (
    <div
      className={cn('flex min-h-0 flex-1 flex-col overflow-hidden', className)}
    >
      {header}
      <div ref={scrollRef} className="block min-h-0 flex-1 overflow-auto">
        {body}
      </div>
      {footer}
    </div>
  );
};
